import Vue from 'vue'
import { create } from './create'
import DialogsWrapper from './wrapper'
import ConfirmModal from './confirm-modal.vue'

export { create, DialogsWrapper, Vue as DialogComponent }

/** vue-modal-dialogs plugin installer */
export default {
  install(Vue, options) {
    Vue.component('DialogsWrapper', DialogsWrapper)

    Vue.prototype.$confirmModal = (...args) => {
      if (typeof args[0] === 'object') {
        let {
          type,
          title,
          content,
          yes = 'Yes',
          yesValue = true,
          no = 'No',
          noValue = false
        } = args[0]

        return create(ConfirmModal)({
          type,
          title,
          content,
          yes,
          yesValue,
          no,
          noValue
        })
      }

      console.log(args)

      return create(
        ConfirmModal,
        'content',
        'title',
        'type'
      )(args[0], args[1], args[2])
    }

    Vue.prototype.$confirmModal.danger = (...args) => {
      return create(
        ConfirmModal,
        'content',
        'title',
        'type'
      )(args[0], 'Warning', 'danger')
    }
  }
}
